import { connect } from "react-redux";
import { PageLibrarySection } from "senac-components";
import { commonSlice, contentSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import {
  LibrarySections,
  PageLibrarySectionPropsDispatch,
  PageLibrarySectionPropsState,
} from "senac-components/dist/pages/Mobile/PageLibrarySection";

import {
  PageLibrarySection as LibraryWeb,
  PageLibrarySectionPropsState as PageLibrarySectionPropsStateWeb,
  PageLibrarySectionWebProps,
  PageLibrarySectionWebPropsDispatch,
} from "senac-components/dist/pages/Web/PageLibrarySection";
import {
  Content,
  ContentGroup,
  ContentMark,
  MenuOptions,
  PageHeaderOptionItem,
  PageLibraryHeaderOptionItem,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import {
  FavoritesInternalTag,
  createTagPage,
  editTagByUid,
  removeFromFavorite,
} from "../store/reducers/userDataSlice";
import {
  loadAndOpenContent,
  showContentDetail,
} from "../store/reducers/contentSlice";
import { filterContent } from "../store/reducers/common";

const mapState = (state: RootState) => {
  var options: LibrarySections[] = [
    LibrarySections.Favorites,
    LibrarySections.Downloads,
    LibrarySections.ReadingList,
    LibrarySections.Marks,
  ];

  if (!state.commonState.runningInMobile) {
    options = options.filter(section => section !== LibrarySections.Downloads);
  }

  let result: PageLibrarySectionPropsState = {
    options: options,
  };

  return result;
};

const getFavoriteContets = (state: RootState) => {
  var allContents = state.contentState.allContents;
  var data = state.userDataState.userData.filter(
    (p) =>
      p.tags &&
      p.tags.length > 0 &&
      p.targetType == "ManagedContent" &&
      p.contextType == "ManagedContent" &&
      p.tags.find((t) => t.name === FavoritesInternalTag) != null
  );
  var uniqueTags = data
    .map((p) => p.tags ?? [])
    .reduce(
      (p, c) => [...new Map([...c, ...p].map((p) => [p.uid, p])).values()],
      []
    )
    .filter((p) => p.name == FavoritesInternalTag);
  var remoteContents = data.filter(
    (p) =>
      p.tags &&
      p.tags.filter((t) => uniqueTags.find((ut) => ut.uid == t.uid)).length > 0
  );
  var contentsUids = [
    ...new Map(
      remoteContents.map((p) => [p.contextUid, p.contextUid])
    ).values(),
  ];
  var contents = contentsUids
    .map((p) => allContents.find((c) => c.uid == p))
    .filter((p) => p) as Content[];
  return contents;
};

const getAppointments = (state: RootState) => {
  var allContent = state.contentState.allContents;
  var data = state.userDataState.userData.filter(
    (p) =>
      p.targetType == "ManagedContentReference" &&
      p.contextType == "ManagedContent"
  );
  var marks: ContentMark[] = [];
  data.forEach((userData) => {
    var mark = marks.find((p) => p.uid == userData.contextUid);
    var content = allContent.find((p) => p.uid == userData.contextUid);
    if (!content) return;

    if (!mark) {
      //todo: alterar para tipo number
      mark = {
        uid: userData.contextUid,
        title: content.title,
        image: content.image,
      };
      marks.push(mark);
    }

    var total = Number.parseInt(mark.numberMark ?? "0");
    total++;

    mark.numberMark = total.toString();
  });

  return marks.map((item) => ({
    ...item,
    appointmentsLength: item.numberMark,
  })) as Content[];
};

const getCollectionLits = (state: RootState) => {
  const userState = state.userDataState;

  var data = [...userState.userData, ...userState.userDataShared].filter(
    (p) =>
      p.tags &&
      p.tags.length > 0 &&
      p.name != FavoritesInternalTag &&
      p.targetType == "ManagedContent" &&
      p.contextType == "ManagedContent"
  );
  var uniqueTags = [...userState.tags, ...userState.sharedTags].filter(
    (p) => p.name != FavoritesInternalTag
  );
  var contentsMap: any = {};

  for (var userData of data) {
    for (var tag of userData.tags ?? []) {
      var list = contentsMap[tag.uid];

      if (!list) {
        list = [];
        contentsMap[tag.uid] = list;
      }

      var contentData = state.contentState.allContents.find(
        (p) => p.uid == userData.contextUid
      );
      if (contentData) list.push(contentData);
    }
  }

  var contents: ContentGroup[] = uniqueTags.map((tag) => {
    var contentGroup: ContentGroup = {
      uid: tag.uid,
      title: tag.name,
      editable: true,
      books: contentsMap[tag.uid],
    };
    return contentGroup;
  });

  return contents;
};
const webMapState = (state: RootState) => {
  var options: LibrarySections[] = [
    LibrarySections.ReadingList,
    LibrarySections.Favorites,
  ];

  const favoritedBooks = getFavoriteContets(state);
  const marked_books = getAppointments(state);
  const collectionList = getCollectionLits(state);
  const result: PageLibrarySectionPropsStateWeb = {
    collectionsList: collectionList,
    options,
    shareds: state.userDataState.sharedTags.map((tag) => tag.uid),
    favorites: [
      {
        uid: "favorites",
        title: "Favoritos",
        books: favoritedBooks,
      },
    ],
    appointments: [
      {
        uid: "appointments",
        title: "Marcações",
        books: marked_books,
      },
    ],
  };
  return result;
};
const mapDispatch = (dispatch: AppDispatch) => {
  const result: PageLibrarySectionPropsDispatch = {
    onSelectedSection: (option: LibrarySections) =>
      dispatch(commonSlice.actions.goToLibraryPage(option)),
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: PageLibraryHeaderOptionItem) =>
      dispatch(commonSlice.actions.goToLibraryOption(option)),
    onSelectedNavigationPageOption: (option: MenuOptions) =>
      dispatch(commonSlice.actions.goToPage(option)),
    onChangeFilter: (filter) => {
      if (filter.query == undefined) return;
      dispatch(filterContent({ query: filter.query }));
    },
  };

  return result;
};

const webmapDispatch = (dispatch: AppDispatch) => {
  const result: PageLibrarySectionWebPropsDispatch = {
    onClickRemoveFavorite: (content) => {
      console.log("checgou o click aqui");
      return dispatch(removeFromFavorite(content));
    },
    onSelectedEditionEpub: (content: Content) =>
      dispatch(loadAndOpenContent(content.uid)),
    onSelectedSection: (option: LibrarySections) =>
      dispatch(commonSlice.actions.goToLibraryPage(option)),
    onSelectedContent: (content: ContentGroup) =>
      dispatch(showContentDetail(content.uid)),
    onEditionGroup: (group: ContentGroup) => dispatch(editTagByUid(group.uid)),
    onChangeFilter: (filter) => {
      if (filter.query == undefined) return;
      dispatch(filterContent({ query: filter.query }));
    },
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: PageLibraryHeaderOptionItem) =>
      dispatch(commonSlice.actions.goToLibraryOption(option)),
    onSelectedNavigationPageOption: (option: MenuOptions) =>
      dispatch(commonSlice.actions.goToPage(option)),
    onCreateList: () => dispatch(createTagPage()),
  };

  return result;
};

const WPageLibrarySection = () => {
  const Mobile = connect(mapState, mapDispatch)(PageLibrarySection);
  const Web = connect(webMapState, webmapDispatch)(LibraryWeb);
  const isMobile = window.innerWidth < 1024;
  if (isMobile) return <Mobile />;
  return <Web />;
};
export { WPageLibrarySection };
